module.exports = __webpack_public_path__ + "img/account.a218b6d1.svg";